import { medias } from '@/utils/sizes';
import { styled } from 'styled-components';

export const LinksContainer = styled.div`
  display: flex;
  flex-direction: column;
  height: 0;
  overflow: hidden;
  transition: height var(--tr-base);

  a {
    opacity: 0;
    transition: opacity var(--tr-base) 0.1s;

    ${medias.max.mobile} {
      font-size: var(--fs-lg);
    }

    &:last-child {
      padding-bottom: 30px;
    }
  }

  &[data-is-displayed='true'] {
    height: var(--height-expanded);

    a {
      opacity: 1;
    }
  }
`;

export const SelectorContainer = styled.div`
  display: flex;
  flex-direction: column;

  .title-all-projects {
    padding-right: var(--spacing-component-inner-xs);
  }

  ${medias.max.mobile} {
    .title-all-projects {
      font-size: var(--fs-lg);
    }
  }

  svg {
    transition: transform var(--tr-base);
  }

  &[data-is-open='true'] {
    svg {
      transform: scaleY(-1);
    }
  }

  a {
    padding: 5px 0;
  }

  button {
    justify-content: flex-start;
  }
`;
